import React, { useState } from 'react';
import { Select, Button, Divider, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputTooltip from 'components/InputInfoCircle';

const SelectOrAdd = ({
  onAdd,
  addButtonLabel = 'Add new option',
  inputTooltip = 'Press Enter to add, or Esc to cancel',
  children,
  ...rest
}) => {
  if (rest.mode === 'tags') {
    throw Error('Do not use with Select tags mode. It does the same thing.');
  }
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [onBlurDisabled, setOnBlurDisabled] = useState(false);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const showInput = () => {
    setInputVisible(true);
  };

  const onDropdownVisibleChange = (open) => {
    if (onBlurDisabled) return;
    setDropdownOpen(open);
  };

  // Use onMouseDown because it fires before onClick
  const onAddButtonMouseDown = () => {
    setOnBlurDisabled(true);
  };

  const handleInputConfirm = (event) => {
    event.stopPropagation();

    setInputValue('');
    setInputVisible(false);
    setOnBlurDisabled(false);

    if (inputValue) {
      onAdd(inputValue);
    }
  };

  const handleInputKeyDown = (event) => {
    if (event.keyCode === 27 /* Esc */ && inputVisible) {
      // Stop it from closing the drawer.
      event.stopPropagation();

      setInputVisible(false);
      setOnBlurDisabled(false);
    }
  };

  const handleInputBlur = () => {
    setInputVisible(false);
    setOnBlurDisabled(false);
  };

  const renderDropDown = menu => (
    <>
      {menu}
      {onAdd && (
        <>
          <Divider style={{ margin: 0 }} />
          {inputVisible ? (
            <Input
              type="text"
              ref={input => input && input.focus()}
              value={inputValue}
              onBlur={handleInputBlur}
              onChange={e => setInputValue(e.target.value)}
              onPressEnter={handleInputConfirm}
              onKeyDown={handleInputKeyDown}
              suffix={<InputTooltip title={inputTooltip} />}
            />
          ) : (
            <Button
              type="link"
              icon={<PlusOutlined />}
              onMouseDown={onAddButtonMouseDown}
              onClick={showInput}
            >
              {addButtonLabel}
            </Button>
          )}
        </>
      )}
    </>
  );

  return (
    <Select
      open={dropdownOpen}
      onDropdownVisibleChange={onDropdownVisibleChange}
      dropdownRender={renderDropDown}
      {...rest}
    >
      {children}
    </Select>
  );
};

export default SelectOrAdd;
